import * as React from "react";
import PageHeader from '../../common/pageheader/PageHeader';
import {
    MessageBar,
    MessageBarType,
    Link
} from '@fluentui/react';

export const CloudCacheReport: React.FC = (props) => {
    return (
        <div>
            <PageHeader
                title="Cloud Cache"
                description="The report contains Cloud Cache HDD utilization information at region level."
            />
            <MessageBar>
                Please go to
                <Link href="https://aka.ms/tesseract/m2cp/cloudcache" inline>
                    aka.ms/tesseract/m2cp/cloudcache
                </Link>{' '}
                to check original report
            </MessageBar>
            <iframe title="M2CP"
                style={{ width: '100%', height: '850px', marginTop: '20px' }}
                src="https://msit.powerbi.com/reportEmbed?reportId=6d2692fa-4e1e-479a-9304-cecc04d566a6&autoAuth=true&ctid=72f988bf-86f1-41af-91ab-2d7cd011db47"
                frameBorder={0}
                allowFullScreen={true}></iframe>
        </div>

    )
}